import React from 'react';
import './AllProducts.css';

function AllProducts({ theme, onBackClick }) {
    return (
        <div className={`app ${theme}`}>
            <main>
                <section className="products-header-section">
                    <div className="products-header">
                        <div>
                            <h1>All Products</h1>
                            <p className="product-count">
                                Still building this disaster carefully.
                            </p>
                        </div>

                        <button className="back-btn" onClick={onBackClick}>
                            Back to Home
                        </button>
                    </div>
                </section>

                <section className="product-section">
                    <div className="placeholder-container">
                        <div className="placeholder-card">
                            <h2>🚧 Still Building It 🚧</h2>
                            <p>
                                Check back later to see the full list of products. I cannot promise it's going to be worth the wait.
                            </p>
                        </div>
                    </div>
                </section>
            </main>

            <footer className="footer">
                <p>
                    © 2026 StupidDesigns.com. All rights reserved.
                    Not that anyone actually wants them.
                </p>
            </footer>
        </div>
    );
}

export default AllProducts;